export default "__VITE_ASSET__Brcgx0Va__"